import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import * as Session from './Session';
import { NumeralThousandsGroupStyleType } from 'cleave.js/options';


export interface UserInteractionContext {
    selected_cmp?: React.Component;
    selected_locatorId?: string;
}

export interface Mountable {
    _isMounted: boolean;
}

export interface Identifyable {
    id: number;
}


export interface AgentChat {
    id: number;
    uid: string;
    title: string;
    lastMessageTime?: Date;
    lastNotifyTime?: Date;
}

export interface AgentTextMessage {
    id: number;
    tags?: string[];
    idauthor: number;
    idgroup?: number;
    messagetime: Date;
    messagetext: string;
    status: string;
    author: Session.PersonalState;
    chatuid?: string;
    idchat?: number;
}

export interface MessageDto<T> {
    result: T;
    alerts?: any[];
    validation?: any[];
}

export interface ErrorMessageDto<T> {
    value: T;
    syshdr: SystemHeader;
    validation?: any[];
}

export interface EntityDto {
    id: number;
    shortname: string;
    fullname: string;
    idcountry: number;
    addresslegal: string;
    addressfact: string;
    reutercode: string;
    phone?: string;
    fax?: string;
    email: string;
    bloombergcode?: string;
    nickname?: string;
}

export interface EntityWLimits extends EntityDto {
    marginTo?: NotesContragentMargin;
    marginFrom?: NotesContragentMargin;
}

export interface Currency {
    id: number;
    name: string;
    shortname: string;
}

export interface Duration {
    id: number;
    name: string;
}

export interface InstrumentHead {
    pos: number;
    id: number;
    fiid: string;
    name: string;
    currency: Currency;
    duration: Duration;
    iavail?: InstrumentAvailabilityDto;
    lotsize?: number;
    //tradeopen: boolean;
}

export interface SystemHeader {
    sstamp: string;
    time?: Date;
    hasfreshchanges: boolean;
}

export interface SystemOperationAvailabilityDto {
    tradesession?: TradeSessionDto;
    instruments: InstrumentAvailabilityDto[];
}

export interface TradeSessionDto {
    isopen: boolean;
    suspended: boolean;
    readonly: boolean;
    sessionopen?: Date;
    sessionclose?: Date;
    willopen?: Date;
}

export interface InstrumentAvailabilityDto {
    fiid: string;
    tradeopen: boolean;
    suspended: boolean;
    readonly: boolean;
    perms: ManipulationPermissionsType[];
}

export interface HubConnection {
    status: 'disconnected' | 'connected' | 'slow' | 'reconnecting';
    time?: Date;
}

export interface AlertMessage {
    message: string;
    context: string;
    time?: Date;
}


export interface AppConfig {
    instruments: InstrumentHead[];
    currencies: Currency[];
    durations: Duration[];
    idapp: number;
    appFamily: string;
    sharedchatid: number;
}

//interface ContactFormRecievedAction {
//    type: 'CONTACT_FORM_RECIEVED',
//    payload: {
//        result: string;
//    }
//}

//interface ContactFormErrorAction {
//    type: 'CONTACT_FORM_ERROR',
//    payload: {
//        form: ContactModel,
//        result: string;
//    }
//}

//export interface Filter_CA {
//    startdate?: Date,
//    finishdate?: Date
//}

//export interface Filter_SEC {
//    startdate?: Date,
//    finishdate?: Date
//}

export interface Instrument {
    header: InstrumentHead,
    bookorders: DomRecord[],
    filter: AgentDSInstrumentFilter
}

export interface Security {
    id: number,
    secid: string,
    logo_url: string,
    isin: string,
    shortname: string,
    name: string
}


export type OrderType = "buy" | "sell";

export const MANIPULATION_PERM_REPEAL = "repeal";
export const MANIPULATION_PERM_TAKE = "take";
export const MANIPULATION_PERM_CONTEXT = "context";

export const MANIPULATION_PERM_FILTER_INCLUDE = "include";
export const MANIPULATION_PERM_FILTER_EXCLUDE = "exclude";

export const MANIPULATION_PERM_ELEMENT_APPEND = "el_append";
export const MANIPULATION_PERM_ELEMENT_REMOVE = "el_remove";
export const MANIPULATION_PERM_ELEMENT_CHANGE = "el_change";

export const MANIPULATION_LOCATOR_TYPE_ID = "id";
export const MANIPULATION_LOCATOR_TYPE_LOOKUP = "lookup";

export type ManipulationPermissionsType = 'repeal' | 'take' | 'context' | 'include' | 'exclude' | 'el_append' | 'el_remove' | 'el_change';


export interface DomRecord {
    manipulation: VMElementManipulationCtx;
    recid: string;

    lot?: number;
    rectime?: Date;
    lastupdate?: Date;
    validtill?: Date;
    stalems?: number;
    buylots?: number;
    buyminlots?: number;
    buysum?: number;
    rate?: number;
    sellsum?: number;
    selllots?: number;
    sellminlots?: number;
    hasownedrecs?: boolean;
    contragent: string;
    contragent_info?: EntityDto;
}

export interface VMElementManipulationCtx {
    locatorId: string;
    perms: ManipulationPermissionsType[];
    justChanged?: boolean;
    timeLastChange?: Date;
}

export interface ManipulationAction<T> {
    locatorType: 'id' | 'lookup'
    locatorId: string | undefined;
    type: ManipulationPermissionsType;
    payload?: T
}

//export interface Order4Deal {
//    manipulation: VMElementManipulationCtx;
//    fiid: string;
//    lotno: number;
//    type: string;
//    sum: number;
//    rate: number;
//    lotcurrency: string;
//    secticker: string;
//    discount: number;
//    contragent: string;
//    secfullname: string;
//    secshortname: string;
//    isowned: boolean;
//}


export interface RecordOrder {
    manipulation: VMElementManipulationCtx;
    proto: NewNotesOrder;
    dealno: string;
    orderno: string;
    orderstatus: string;
    orderstatuscode: string;
    lottype: string;
    duration: string;
    instrument: string;
    sum: number;
    sumavail: number;
    minlot: number;
    lotcurrency: string;
    rate: number;
    price: number;
    discount: number;
    secticker: string;
    secfullname: string;
    contragent: string;
    isowned: boolean;
    contragent_info?: EntityDto;
    trader: Session.PersonalState;
    lot?: number;
    sum_lots: number;
    sumavail_lots: number;
    minlot_lots: number;
    placetime?: Date;
    validtill?: Date,
    margin?: NotesContragentMargin;
}

export interface OrderBookRecords {
    filter?: AgentDSPeriodFilter;
    ordbook_records?: RecordOrder[]
}



export interface NewOrderAccept {
    orderid: string;
    sum: number;
    //discount: number;
}

export interface NewNotesOrderAccept extends NewOrderAccept {
    sum_lots: number;
}

export interface OrderAccept {
    id: number;
    deal: any;
    order: any;
    personacceptor: any;
}


export interface NewOrder {
    currency_id: number;
    duration_id: number;
    type: OrderType;
    rate: number;
    discount: number;
    sum: number;
    minlot: number;
    securityid: string;
    comment?: string;
}

export interface OrderContragentMark {
    id: number;
    idcontragent: number;
    agentvisible?: boolean;
}

export interface NewNotesOrder extends NewOrder {
    lot?: number;
    sum_lots: number;
    minlot_lots: number;
    agentnamevis?: string;
    agentmarks?: OrderContragentMark[];
    withdrawtype: string;
    withdrawtime?: Date;
    withdrawtime_str: string;
    timespantime?: Date;
    timespantime_str: string;
}

export interface NewNotesContragentMarginPick {
    //idcurrency: number;
    //idduration: number;
    idinstrument: number;
    givemargin: number;
}


export interface NotesContragentMarginPick {
    id: number;
    //idcurrency: number;
    //idduration: number;
    idinstrument: number;

    givemargin: number;
    givenorder: number;
    givendeal: number;
    free2giveorder: number;
    free2givedeal: number;
}

export interface NotesContragentMargin {
    id?: number;
    idagent?: number;
    idcontragent: number;
    allowed: boolean;
    alertnote: string;
    margins: NotesContragentMarginPick[];
}

export interface CommandReason {
    message: string;
}

export interface CommandContext {
    context: any;
}


export interface AgentDSContext {
    instrumentsDS: AgentDSInstrumentGroup;
    myOrdersDS: AgentDSMyOrdersGroup;
    myDealsDS: AgentDSMyDealsGroup;
}

export interface AgentDSInstrumentGroup {
    instruments: AgentDSInstrumentFilter[];
}

export interface AgentDSMyOrdersGroup {
    periodFilter: AgentDSPeriodFilter;
    attributesFilter: AgentDSAttributesFilter;
}

export interface AgentDSMyDealsGroup {
    periodFilter: AgentDSPeriodFilter;
    attributesFilter: AgentDSAttributesFilter;
}

export interface AgentDSAttributesFilter {
    isMyOwnOnly: boolean;
}

export interface AgentDSPeriodFilter {
    isCurrentPeriod: boolean;
    startDateIncl?: Date;
    finishDateIncl?: Date;
}

export interface AgentDSInstrumentFilter {
    fiid: string;
    isContragentLimits: boolean;
    isSecuritiesFilters: boolean;
}


export interface ToastMessage {
    text: string;
    action: boolean;
}

export interface ChatUserState {
    personalState: Session.PersonalState;
    connectStatus: 'Online' | 'Offline' | 'Away';
    lastMessageTime?: Date;
    lastNotifyTime?: Date;
}


export interface ChatState {
    IdChat?: number;
    title?: string;
    privatechatuser?: ChatUserState;
}


export interface AgentChatActivity {
    idchat: number;
    idperson: number;
    lastread: Date;
    lastmodify: Date;
}

export interface MarketQuotes {
    forexquotes: ForexQuote[];
}

export interface ForexQuote {
    basecur: string;
    quotecur: string;
    bid: number;
    ask: number;
    price: number;
    quotetime: Date;
    askchange: string;
    bidchange: string;
    pricechange: string;
    isactual: boolean;
}


export interface ProfileSettings {
    idperson: number;
    disconnectProcess: 'none' | 'droporders';
    disconnectTimeoutSpan?: Date;
    disconnectTimeoutSpan_str: string;

}








































//import * as React from 'react';
//import { RouteComponentProps } from 'react-router';
//import * as Session from './Session';
//import { NumeralThousandsGroupStyleType } from 'cleave.js/options';


//export interface UserInteractionContext {
//    selected_cmp?: React.Component;
//    selected_locatorId?: string;
//}


//export interface AgentTextMessage {
//    id: number;
//    tags?: string[];
//    idauthor: number;
//    idgroup?: number;
//    messagetime: Date;
//    messagetext: string;
//    status: string;
//    author: Session.PersonalState;
//}

//export interface MessageDto<T> {
//    result: T;
//    alerts?: any[];
//    validation?: any[];
//}

//export interface ErrorMessageDto<T> {
//    value: T;
//    syshdr: SystemHeader;
//    validation?: any[];
//}

//export interface EntityDto {
//    id: number;
//    shortname: string;
//    fullname: string;
//    idcountry: number;
//    addresslegal: string;
//    addressfact: string;
//    reutercode: string;
//    phone?: string;
//    fax?: string;
//    email: string;
//    bloombergcode?: string;
//}

//export interface Currency {
//    id: number;
//    name: string;
//    shortname: string;
//}

//export interface Duration {
//    id: number;
//    name: string;
//}

//export interface InstrumentHead {
//    pos: number;
//    fiid: string;
//    name: string;
//    currency: Currency;
//    duration: Duration;
//    iavail?: InstrumentAvailabilityDto;
//    //tradeopen: boolean;
//}

//export interface SystemHeader {
//    sstamp: string;
//    time?: Date;
//    hasfreshchanges: boolean;
//}

//export interface SystemOperationAvailabilityDto {
//    tradesession?: TradeSessionDto;
//    instruments: InstrumentAvailabilityDto[];
//}

//export interface TradeSessionDto {
//    isopen: boolean;
//    suspended: boolean;
//    readonly: boolean;
//    sessionopen?: Date;
//    sessionclose?: Date;
//    willopen?: Date;
//}

//export interface InstrumentAvailabilityDto {
//    fiid: string;
//    tradeopen: boolean;
//    suspended: boolean;
//    readonly: boolean;
//    perms: ManipulationPermissionsType[];
//}

//export interface HubConnection {
//    status: 'disconnected' | 'connected' | 'slow' | 'reconnecting';
//    time?: Date;
//}

//export interface AlertMessage {
//    message: string;
//    context: string;
//    time?: Date;
//}


//export interface AppConfig {
//    instruments: InstrumentHead[];
//    currencies: Currency[];
//    durations: Duration[];
//}

////interface ContactFormRecievedAction {
////    type: 'CONTACT_FORM_RECIEVED',
////    payload: {
////        result: string;
////    }
////}

////interface ContactFormErrorAction {
////    type: 'CONTACT_FORM_ERROR',
////    payload: {
////        form: ContactModel,
////        result: string;
////    }
////}

////export interface Filter_CA {
////    startdate?: Date,
////    finishdate?: Date
////}

////export interface Filter_SEC {
////    startdate?: Date,
////    finishdate?: Date
////}

//export interface Instrument {
//    header: InstrumentHead,
//    bookorders: DomRecord[],
//    filter: AgentDSInstrumentFilter
//}

//export interface Security {
//    id: number,
//    secid: string,
//    logo_url: string,
//    isin: string,
//    shortname: string,
//    name: string
//}


//export type OrderType = "buy" | "sell";

//export const MANIPULATION_PERM_REPEAL = "repeal";
//export const MANIPULATION_PERM_TAKE = "take";
//export const MANIPULATION_PERM_CONTEXT = "context";

//export const MANIPULATION_PERM_FILTER_INCLUDE = "include";
//export const MANIPULATION_PERM_FILTER_EXCLUDE = "exclude";

//export const MANIPULATION_LOCATOR_TYPE_ID = "id";
//export const MANIPULATION_LOCATOR_TYPE_LOOKUP = "lookup";

//export type ManipulationPermissionsType = 'repeal' | 'take' | 'context' | 'include' | 'exclude';


//export interface DomRecord {
//    manipulation: VMElementManipulationCtx;
//    recid: string;
//    lastupdate?: Date,
//    stalems?: number;
//    buylots?: number;
//    buysum?: number;
//    rate?: number;
//    sellsum?: number;
//    selllots?: number;
//    hasownedrecs?: boolean;
//}

//export interface VMElementManipulationCtx {
//    locatorId: string;
//    perms: ManipulationPermissionsType[];
//    justChanged?: boolean;
//    timeLastChange?: Date;
//}

//export interface ManipulationAction<T> {
//    locatorType: 'id' | 'lookup'
//    locatorId: string | undefined;
//    type: ManipulationPermissionsType;
//    payload?: T
//}

////export interface Order4Deal {
////    manipulation: VMElementManipulationCtx;
////    fiid: string;
////    lotno: number;
////    type: string;
////    sum: number;
////    rate: number;
////    lotcurrency: string;
////    secticker: string;
////    discount: number;
////    contragent: string;
////    secfullname: string;
////    secshortname: string;
////    isowned: boolean;
////}


//export interface RecordOrder {
//    manipulation: VMElementManipulationCtx;
//    proto: NewOrder;
//    orderno: string;
//    orderstatus: string;
//    orderstatuscode: string;
//    lottype: string;
//    duration: string;
//    sum: number;
//    sumavail: number;
//    minlot: number;
//    lotcurrency: string;
//    rate: number;
//    discount: number;
//    secticker: string;
//    secfullname: string;
//    contragent: string;
//    isowned: boolean;
//    contragent_info?: EntityDto;
//    trader: Session.PersonalState;
//}

//export interface OrderBookRecords {
//    filter?: AgentDSPeriodFilter;
//    ordbook_records?: RecordOrder[]
//}


//export class NewOrderAccept {
//    orderid: string;
//    sum: number;
//    //discount: number;
//}

//export class OrderAccept {
//    id: number;
//    deal: any;
//    order: any;
//    personacceptor: any;
//}


//export class NewOrder {
//    currency_id: number;
//    duration_id: number;
//    type: OrderType;
//    rate: number;
//    discount: number;
//    sum: number;
//    minlot: number;
//    securityid: string;
//    comment: string;
//}


//export interface CommandReason {
//    message: string;
//}

//export interface CommandContext {
//    context: any;
//}


//export interface AgentDSContext {
//    instrumentsDS: AgentDSInstrumentGroup;
//    myOrdersDS: AgentDSMyOrdersGroup;
//    myDealsDS: AgentDSMyDealsGroup;
//}

//export interface AgentDSInstrumentGroup {
//    instruments: AgentDSInstrumentFilter[];
//}

//export interface AgentDSMyOrdersGroup {
//    periodFilter: AgentDSPeriodFilter;
//}

//export interface AgentDSMyDealsGroup {
//    periodFilter: AgentDSPeriodFilter;
//}

//export interface AgentDSPeriodFilter {
//    isCurrentPeriod: boolean;
//    startDateIncl?: Date;
//    finishDateIncl?: Date;
//}

//export interface AgentDSInstrumentFilter {
//    fiid: string;
//    isContragentLimits: boolean;
//    isSecuritiesFilters: boolean;
//}

